import { Bell, Search } from 'lucide-react';

/* No status chip here.

   It used to read "VitalPBX · tenant marshwells", which was removed because
   customers have no business knowing which platform serves them. What was
   left — a green dot saying "Connected" on every page — was hardcoded: it
   never went red, never reflected anything, and reassured about a thing
   nobody had asked about. Live state that means something now lives where it
   applies: the Extensions tab, per handset.

   If a real "your service is impaired" indicator is ever wanted, it should be
   driven by something that can actually say no. */
export default function Topbar({ title }) {
  return (
    <div className="topbar">
      <h1 className="topbar__title">{title}</h1>

      <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
        <div className="search">
          <Search size={15} color="var(--ink-soft)" className="search__icon" />
          <input className="search__input" placeholder="Search calls, numbers…" aria-label="Search" />
        </div>
        <button
          type="button"
          aria-label="Notifications"
          style={{ border: 'none', background: 'none', cursor: 'pointer', padding: 0, display: 'flex' }}
        >
          <Bell size={18} color="var(--ink-soft)" />
        </button>
      </div>
    </div>
  );
}
